import type { RefObject } from "react";
import { useEffect, useState } from "react";

/*
    This hook lets you know if the element referenced by ref is in the viewport
 */
export const useInViewport = (ref: RefObject<Element | null>) => {
    const [isIntersecting, setIntersecting] = useState(false);

    const observer = new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting));

    useEffect(() => {
        if (ref.current) {
            observer.observe(ref.current);
        }
        // Remove the observer once component is unmounted
        return () => {
            observer.disconnect();
        };
    }, [ref]);

    return isIntersecting;
};
